import {createApp, ref} from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import helper from "@/utils/helper";

import './registerServiceWorker'

import './assets/main.css'
import fcmToken from "@/utils/fcm";

const app = createApp(App)
// Global Var for Network Loading
app.config.globalProperties.$loading = ref(true)

fcmToken().then(token => console.log(token))

app
    .use(store)
    .use(router)
    .use(helper)
    .mount('#app')

export default app